import * as Yup from 'yup'
import { InEditingMode, InEditingCompany } from "../../states/GlobalState"
import Api from '../../services/api'
// import DateFnsUtils from '@date-io/date-fns'
// import { it } from 'date-fns/locale';
import ValidationCache from '../../utils/validationCache';
import { OptionType } from '../../types/constants';
import uuid from 'uuidv4'
import { Company } from '../../models/company';

const passwordValidationRegex = /^.*(?=.{8,})(?=.*\d)(?=.*[@#$%^&+=_.!])(?=.*[A-Z]).*$/
const passwordValidationHint = "La password deve essere lunga almeno 8 caratteri, contenere almeno un numero, un carattere maiuscolo ed un carattere speciale: @#$%^&+=_.!"
const validationCache = new ValidationCache('default', 60000);

const setCacheName = (newName: string) => {
    validationCache.setName(newName)
}
const clearCache = () => {
    validationCache.clear()
}
const reformatQuery = (query: string) => {
    let q = query.replace(/[_]/g, '[_]').replace(/[*]/g, '%')
    if(q.endsWith('$')) {
        console.log('query finisce per $')
        q = q.replace(/[$]$/, '')
    } else if(!q.endsWith('%')) {
        q += '%'
    }
    q = q.replace(/%/g, '%25').replace(/[ ]/g, '%20').replace(/#/g, '%23')
    return q
}

// const dateFns = new DateFnsUtils({locale: it})
// const isExpired = (pwexp: DateTimeISO) => {
//     return dateFns.date(pwexp).getTime() < Date.now()
// }

// const isAcceptable = (ubo: Company, filters: UsersFilterType) => {
//     return !(
//         (filters.pwExpireFilter && ((filters.noPwExpire && isExpired(ubo.pwExpire)) || (!filters.noPwExpire && !isExpired(ubo.pwExpire)))) ||
//         (filters.lockedFilter && ((!filters.onlyLocked && ubo.isLocked) || (filters.onlyLocked && !ubo.isLocked)))
//     )
// }

// const newInEditCompany = (newId: number) => {
//     const newCompany: InEditingCompany = {
//         Id: newId,
//         BusinessName: '',
//         VatNumber: '',
//         TaxCode: '',
//         UiLogoUrl: '',
//         InsertDate: '',
//         InsertUser: '',
//         UpdateDate: '',
//         UpdateUser: '',
//         IsLocked: false,
//         modified: true,
//         mode: InEditingMode.New,
//     }
//     return newCompany
// }

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export class WhatsNewServiceValidation {
    levels: OptionType[];
    // ownerContext: string;
    // checkOwnerContextErrorMessage: string;

    // checkOwnerContext = (value: string) => {
    //     value = value || ''
    //     console.log(`checkOwnerContext ${value}`)
    //     return (value.startsWith(this.ownerContext))
    // }

    constructor(adLevels: OptionType[]) {
        // console.log(`UserServiceValidation.ctor ${adRole}`)
        this.levels = adLevels;
        // this.ownerContext = adOwnerContext
        // this.checkOwnerContextErrorMessage = `L'owner deve iniziare per ${this.ownerContext}`
    }

    whatsNewFormSchemaBase = () => {
        // const ownerContext = this.ownerContext;
        return Yup.object().shape({
            oid: Yup.number(),
            Id: Yup.number().label('Id').required(),
            Version: Yup.string().label('Version').required('La versione whatsNew è obbligatoria'),
            // HtmlContent: Yup.string().label('HtmlContent').required('Il content è obbligatorio'),
            ExpirationDate: Yup.string().label('TaxCode').nullable(),
            // InsertDate: Yup.string().label('InsertDate'),
            // InsertUser: Yup.string().label('InsertUser'),
            // UpdateDate: Yup.string().label('UpdateDate'),
            // UpdateUser: Yup.string().label('UpdateUser'),
            })
    }
    
    // companySchema = () => Yup.object().shape({
    //     oid: Yup.number(),
    //     id: Yup.string(),
    //     BusinessName: Yup.string(),
    //     VatNumber: Yup.string(),
    //     TaxCode: Yup.string(),
    // })
    
    // checkUnicity(this: any, value: string) {
    //     let item = validationCache.getItem(value)
    //     if(item !== undefined) {
    //         return item.value
    //     }
    //     if(value) {
    //         return Api.validId(value).then(valid => {
    //             validationCache.put(value, valid)
    //             return valid
    //         })
    //     }
    //     validationCache.put(value, false)
    //     return false;
    // }
}

export default {
    // newInEditCompany,
    setCacheName,
    clearCache,
    reformatQuery,
}